import React from 'react';
import cn from 'classnames';

import Locale from '../../Translate/Locale';
import ValidationError from '../../common/ValidationError';
import Text from '../../common/Text';
import DangerIcon from '../../../icons/intents/danger.svg';

import styles from './InputContainer.scss';

export type InputContainerProps = {
  label: string;
  labelFor: string;
  labelIsRequired?: boolean;
  labelHasWarning?: boolean;
  errorWithTranslation?: string;
  children: React.ReactNode;
  topRightElement?: React.ReactNode;
  helpText?: string;
};

function InputContainer(props: InputContainerProps) {
  const {
    label,
    labelFor,
    labelIsRequired,
    labelHasWarning,
    errorWithTranslation,
    children,
    topRightElement,
    helpText,
  } = props;

  return (
    <div className={styles.inputContainer}>
      <div className={styles.header}>
        <div>
          {label && (
            <label className={cn(styles.label, { [styles.required]: labelIsRequired })} htmlFor={labelFor}>
              <Locale>{label}</Locale>
            </label>
          )}
          {labelHasWarning && <DangerIcon className={cn(styles.icon, styles.warning)} />}
        </div>
        <div className={styles.rightContent}>{topRightElement}</div>
      </div>
      {children}
      {errorWithTranslation && (
        <div className={styles.validationError}>
          <ValidationError>{errorWithTranslation}</ValidationError>
        </div>
      )}
      {helpText && (
        <Text className={styles.helpText}>
          <Locale>{helpText}</Locale>
        </Text>
      )}
    </div>
  );
}

export default React.memo(InputContainer);
